import React, { useState } from "react";
import { Redirect, Route } from "react-router-dom";
import auth from "./auth.js";

const ProtectedRoute = ({ component: Component, ...rest }) => {
    const [userData, setUserData] = useState(auth.getUser())
    return (
        <Route
            {...rest}
            render={props => {
                if (auth.isAuthenticated()) {
                    return <Component user={userData} renew={setUserData} {...props} />;
                } else {
                    return <Redirect to={
                        {
                            pathname: "signin/main",
                            state: {
                                from: props.location
                            }
                        }
                    } />
                }
            }}
        />
    );
};

export default ProtectedRoute;